import React from 'react';
import './Stats.css';

const stats = [
  { num: 'PAN', unit: 'India', label: 'Service Coverage', icon: 'bi-geo-alt' },
  { num: '5+',  unit: '',      label: 'Equipment Types',  icon: 'bi-tools' },
  { num: 'AMC', unit: 'Plans', label: 'Zero Downtime',    icon: 'bi-shield-check' },
  { num: '24',  unit: '/7',    label: 'Engineer Support', icon: 'bi-headset' },
];

function Stats() {
  return (
    <div className="stats-bar">
      <div className="container">
        <div className="row g-0">
          {stats.map((s, i) => (
            <div className="col-6 col-md-3" key={i}>
              <div className={`stat-item ${i < stats.length - 1 ? 'stat-divider' : ''}`}>
                <i className={`bi ${s.icon} stat-icon`}></i>
                <div className="stat-number">
                  {s.num}<span className="stat-unit">{s.unit}</span>
                </div>
                <div className="stat-label">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Stats;
